import { RootInitialState } from 'core/common/store/rootReducer';
import { UtmSource } from 'core/user/entities';

export const getUtmAdGroup = (state: RootInitialState) => {
  return state.userUtmTags.tags.ad_group;
};

export const getUtmSource = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_source ?? UtmSource.NO_SOURCE;
};

export const getUtmTags = (state: RootInitialState) => {
  return state.userUtmTags.tags;
};

export const getUtmAdName = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_ad_name;
};

export const getUtmContent = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_content;
};

export const getUtmCookies = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_cookies ?? '';
};

export const getUtmCampaign = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_campaign;
};

export const getUtmCreoGroup = (state: RootInitialState) => {
  return state.userUtmTags.tags.utm_creo_group;
};
